import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';
import { ApiCategory } from '@features/category/domain/models/category.models';

@Injectable()
export class MarketCategoryRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService
    ) {}

    public getTranslatedCategory(storeId, catalogId, languageId, categoryId): Observable<ApiCategory> {
        const slug = `catalog/store/${storeId}/${catalogId}/category/${categoryId}`;

        const url = this.requestService.requestUrl(slug, languageId, null, true);

        return this.http.get<ApiCategory>(url);
    }
}
